"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.illuminance = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const tsdb_1 = require("../tsdb");
const VariableName_1 = require("../VariableName");
exports.illuminance = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __tsdb_data_type: true,
    __variable_name_data_type: true,
    id: 'illuminance',
    variableName: VariableName_1.VariableName.illuminance,
    dbTable: tsdb_1.TSDBTable.illuminance,
    title: 'Illuminance',
    icon: free_solid_svg_icons_1.faLightbulb,
    isSlotted: true,
    order: 7,
    graphQLSampleKey: 'illuminance',
    bucketing: {
        min: 0,
        max: 1000000,
        numberOfBuckets: 6,
    },
    colormap: [
        { value: 0, rgb: [50, 50, 50, 1] },
        { value: 180000, rgb: [255, 246, 0, 1] },
        { value: 1000000, rgb: [255, 255, 255, 1] },
    ],
    unit: `lux`,
    dataPointConverter: value => Math.round(value / 1000),
    decimals: 1,
};
//# sourceMappingURL=illuminance.js.map